import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";

const initialState = {
  ...defaultState("skus", { metadata: undefined }, []),
};

const editSkuSuccess = (state, draft, payload) => {
  const index = state.skus.findIndex((r) => r.id === payload.id);
  if (index >= 0) {
    draft.skus[index] = payload;
  }
  draft.openDialog = false;
};

const skuCreatedSuccess = (state, draft, payload) => {
  const skus = state.skus || [];
  draft.skus = [...skus, payload];
  draft.openDialog = false;
};

const skuDeleteSuccess = (state, draft, payload) => {
  const skus = state.skus || [];
  draft.skus = skus.filter((a) => a.id != payload.id);
  draft.openDeleteDialog = false;
};

const showDialog = (state, draft, payload) => {
  draft.openDialog = true;
};

const showDeleteDialog = (state, draft, payload) => {
  draft.openDeleteDialog = true;
};

const resetDialog = (state, draft, payload) => {
  draft.openDialog = false;
  draft.openDeleteDialog = false;
};

export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {
    action: "getAllSkus",
    stateName: "skus",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "createSku",
    stateName: "sku",
    async: true,
    isPaginated: false,
    successCb: skuCreatedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editSku",
    stateName: "sku",
    async: true,
    isPaginated: false,
    successCb: editSkuSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "deleteSku",
    stateName: "sku",
    async: true,
    isPaginated: false,
    successCb: skuDeleteSuccess,
  }),

  ...bindReducers(ActionTypes, {
    action: "showDeleteDialog",
    stateName: "showDeleteDialog",
    async: false,
    isPaginated: false,
    successCb: showDeleteDialog,
  }),

  ...bindReducers(ActionTypes, {
    action: "showDialog",
    stateName: "showDialog",
    async: false,
    isPaginated: false,
    successCb: showDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "resetDialog",
    stateName: "resetDialog",
    async: false,
    isPaginated: false,
    successCb: resetDialog,
  }),
});
